module.exports = __webpack_public_path__ + "zvetseni-prsou_15_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_15_after.jpg
// module id = 1303
// module chunks = 0